import {
    REQUEST_GET_UNDERWRITERS,
    RECEIVE_GET_UNDERWRITERS,
    ERROR_GET_UNDERWRITERS,

    REQUEST_GET_AUTHORIZED_UNDERWRITERS,
    RECEIVE_GET_AUTHORIZED_UNDERWRITERS,
    ERROR_GET_AUTHORIZED_UNDERWRITERS,

    REQUEST_ADD_INTERNET_USER,
    RECEIVE_ADD_INTERNET_USER,
    ERROR_ADD__INTERNET_USER,

    REQUEST_REMOVE_INTERNET_USER,
    RECEIVE_REMOVE_INTERNET_USER,
    ERROR_REMOVE_INTERNET_USER,
} from '../../typeConstants';
import { customer as initialState } from '../initialState.tsx';

const underwriter = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_GET_UNDERWRITERS:
            return {
                ...state,
                isFetchingUnderwriters: true,
            };
        case RECEIVE_GET_UNDERWRITERS:
            return {
                ...state,
                userUnderwriters: action.payload,
                isFetchingUnderwriters: false,
            };
        case ERROR_GET_UNDERWRITERS:
            return {
                ...state,
                isFetchingUnderwriters: false,
            };
        case REQUEST_GET_AUTHORIZED_UNDERWRITERS:
            return {
                ...state,
                isFetchingAuthorizedUnderwriters: true,
            };
        case RECEIVE_GET_AUTHORIZED_UNDERWRITERS:
            return {
                ...state,
                authorizedUnderwriters: action.payload,
                isFetchingAuthorizedUnderwriters: false,
            };
        case ERROR_GET_AUTHORIZED_UNDERWRITERS:
            return {
                ...state,
                isFetchingAuthorizedUnderwriters: false,
            };
        case REQUEST_ADD_INTERNET_USER:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_ADD_INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_ADD__INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        case REQUEST_REMOVE_INTERNET_USER:
            return {
                ...state,
                updatingUser: true,
            };
        case RECEIVE_REMOVE_INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        case ERROR_REMOVE_INTERNET_USER:
            return {
                ...state,
                updatingUser: false,
            };
        default:
            return state;
    }
};

export default underwriter;
